import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import Resumelist from "../ResumeList/Resumelist";
import Modal from "react-bootstrap/Modal";
import "./Picktemplate.scss";
import {
  changeTemplateActions,
  getTemplateId,
  templateGetParticularActions,
  coverTemplateGetParticularActions,
  templateCountAdd,
} from "../../Store/Actions/TemplateActions";
import {
  resumeEditActions,
  sampleResumeById,
} from "../../Store/Actions/ResumeActions";
import TemplateListContainer from "./TemplateListContainer";
import { useParams } from "react-router";
import { TemplateContext } from "../../Context/templateContext";
import { useHistory } from "react-router";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { style } from "../../masterData";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import LoginPopup from "../Modals/LoginPopup/LoginPopup";
import { changeLayout } from "../../Store/Actions/LayoutActions";
import { EDITOR_DATA_ADD } from "../../Store/Constants/EditorConstants";
import { COVER_DATA_ADD } from "../../Store/Constants/EditorConstants";
import { sampleCoverById } from "../../Store/Actions/CoverLetterActions";
import { coverEditActions } from "../../Store/Actions/CoverLetterActions";

function Picktemplate(props) {
  const { id } = useParams();
  const history = useHistory();
  const path = window.location.pathname;
  const [templateId, setTemplateId] = useState(
    process.env.REACT_APP_DEFAULT_TEMPLATE_CODE
  );
  const dispatch = useDispatch();
  const [showOverlay, setShowOverlay] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  const [changeId, setChangeId] = useState(
    process.env.REACT_APP_DEFAULT_TEMPLATE_CODE
  );
  const [resumeData, setResumeData] = useState("");
  const [allTitle, setAllTitle] = useState("");
  const [paidTitle, setPaidTitle] = useState("");
  const [getTemplateData, setGetTemplateData] = useState("");
  const resume = useSelector((state) => state.resumeGetById);
  const [image, setImage] = useState("");
  const [customization, setCustomization] = useState(style);
  const [total, setTotal] = useState("");
  const [current, setCurrent] = useState(0);
  const [particularData, setParticularData] = useState("");
  // const getData = useSelector((state) => state.templateList.list);
  const editorData = useSelector((state) => state.editorData);
  const templateData = useSelector((state) => state.TemplateParticular.data);
  const [tempData, setTempData] = useState("");
  const getData = useSelector((state) => state.CoverTemplates.list);
  const { coverLetter } = useSelector((state) => state.coverParticular);

  const { userType, setUserType } = useContext(userTypeContext);
  //Template Popup
  const { showTemplate, setShowTemplate } = useContext(TemplateContext);

  useEffect(() => {
    if (getData && getData.length > 0) {
      let template_Array = [];
      getData &&
        getData
          .filter((data) => data.status == "1")
          .map((res, index) => {
            if (index == 0) {
              setParticularData(res);
            }
            template_Array.push(res);
          });
      setGetTemplateData(template_Array);
      setTotal(template_Array.length);
    } else {
      let template_Array = [];
      getData &&
        getData.data &&
        getData.data
          .filter((data) => data.status == "1")
          .map((res, index) => {
            if (index == 0) {
              setParticularData(res);
            }
            template_Array.push(res);
          });
      setGetTemplateData(template_Array);
      setTotal(template_Array.length);
      //   getData && getData && setGetTemplateData(getData.data);
      //   setTotal(getData && getData.data && getData.data.length);
      //   setParticularData(getData && getData.data && getData.data[0]);
    }
    setCurrent();
  }, [getData, resumeData]);

  useEffect(() => {
    let image;
    getTemplateData &&
      getTemplateData
        .filter((data) => data.template_code == templateId)
        .map(
          (maping, index) => (
            (image = JSON.parse(maping.image)), setImage(image.key)
          )
        );
    const index =
      getTemplateData &&
      getTemplateData.findIndex((res) => res.id === templateId);
    setCurrent(index);
  }, [props]);

  useEffect(() => {
    setResumeData(coverLetter);
  }, [coverLetter]);

  const changeTemplate = (responseId, customization, type, templateData) => {
    setChangeId(responseId);
    setCustomization(customization);
    setParticularData(templateData);
    setTemplateId(templateData?.id);
  };

  useEffect(() => {
    {
      setAllTitle(
        "All (" +
          `${
            getTemplateData &&
            getTemplateData.filter((data) => data.status == "1").length
          }` +
          ")"
      );
      setPaidTitle(
        "Premium Templates (" +
          `${
            getTemplateData &&
            getTemplateData
              .filter((data) => data.usage == "2")
              .filter((data) => data.status == "1").length
          }` +
          ")"
      );
    }
  }, [getTemplateData]);

  const sampleSet = () => {
    if (path && path.includes("create")) {
      dispatch(
        coverTemplateGetParticularActions(particularData?.template_code)
      );

      let cont = particularData;
      let data = { ...props.resumeFields };
      //   data["sectionPosition"] =
      //     cont && cont.settings && cont.settings.sectionPosition;
      data["editorSettings"] =
        cont && cont.settings && cont.settings.editorSettings;
      //   data["layout"] = cont && cont.settings && cont.settings.layout;

      // For Premium Handle

      const checkLockedFeature =
        data["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        data["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        data &&
        data["lockedFeatures"] &&
        data["lockedFeatures"].findIndex((obj) => obj === "template");
      // let res = { ...editorData }
      if (particularData && particularData.usage == "2") {
        if (objWithIdIndex === -1) {
          data["lockedFeatures"].push("template");
        }
      } else {
        if (
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].length > 0
        ) {
          if (objWithIdIndex > -1) {
            data &&
              data["lockedFeatures"] &&
              data["lockedFeatures"].splice(objWithIdIndex, 1);
          }
        }
      }

      data.customization = particularData?.settings.customization;
      data.template_id = particularData?.template_code;
      props.setResumeFields(data);
      dispatch({
        type: COVER_DATA_ADD,
        payload: data,
      });
      dispatch(sampleCoverById(id, data, "isAuth"));
    } else {
      dispatch(
        coverTemplateGetParticularActions(particularData?.template_code)
      );
      dispatch(templateCountAdd(particularData?.template_code));

      let cont = particularData;
      let data = { ...props.resumeFields };

      data["editorSettings"] =
        cont && cont.settings && cont.settings.editorSettings;

      const checkLockedFeature =
        data["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        data["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        data &&
        data["lockedFeatures"] &&
        data["lockedFeatures"].findIndex((obj) => obj === "template");
      // let res = { ...editorData }
      if (particularData && particularData.usage == "2") {
        if (objWithIdIndex === -1) {
          data["lockedFeatures"].push("template");
        }
      } else {
        if (
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].length > 0
        ) {
          if (objWithIdIndex > -1) {
            data &&
              data["lockedFeatures"] &&
              data["lockedFeatures"].splice(objWithIdIndex, 1);
          }
        }
      }

      data.customization = particularData.settings.customization;
      props.setResumeFields(data);
      dispatch({
        type: COVER_DATA_ADD,
        payload: data,
      });
      const body = {
        title:
          coverLetter && coverLetter && coverLetter.title
            ? coverLetter.title
            : "",
        body: "Body123",
        content: JSON.stringify(data),
        completed: false,
        isLetter:
          coverLetter && coverLetter && coverLetter.isLetter
            ? coverLetter.isLetter
            : 0,
        type: "cover_letter",
        template_id: particularData.template_code,
      };

      dispatch(coverEditActions(id, body));
      //   history.push(`/resumes/${id}`);
    }
    setShowTemplate(false);
  };

  const imgClick = (id) => {
    setTemplateId(id);
  };

  const sampleHide = () => {
    if (path.includes("create")) {
      history.push(`/create-cover/sample/${id}`);
    } else {
      history.push(`/coverletter/${id}`);
    }
    // props.samplehide();
    setShowTemplate(false);
  };
  useEffect(() => {
    if (tempData && tempData.status && tempData.status == "2") {
      setTemplateId(process.env.REACT_APP_DEFAULT_COVER_TEMPLATE_CODE);
    } else {
      setTemplateId(resumeData && resumeData.template_id);
    }
  }, [props]);

  useEffect(() => {
    const index =
      getTemplateData &&
      getTemplateData.findIndex((res) => res.id == templateId);
    setCurrent(index);
  }, [resumeData, templateId, getTemplateData]);

  const handlePrevious = () => {
    if (current <= 0) {
      return;
    } else {
      let next = getTemplateData[current - 1];
      setChangeId(next.id);
      setTemplateId(next.id);
      const image = JSON.parse(next.image);
      setImage(image.key);
      setCurrent(current - 1);
      setParticularData(next);
    }
  };
  const handleNext = () => {
    if (current >= total - 1) {
      return;
    } else {
      let next = getTemplateData[current + 1];
      setChangeId(next.id);
      setTemplateId(next.id);
      const image = JSON.parse(next.image);
      setImage(image.key);
      setCurrent(current + 1);
      setParticularData(next);
    }
  };

  useEffect(() => {
    setTempData(templateData);
  }, [templateData]);

  const handleHide = () => {
    setShowLogin(false);
  };

  return (
    <>
      <Modal
        className="sample-resume-modal "
        show={showTemplate}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="sample-resume-modal-body">
          <LoginPopup show={showLogin} hide={handleHide} />

          <div className=" row">
            <div className="d-block d-sm-block   col-12 col-sm-12 col-md-4  sample_img_section">
              <div className="resumesampleheader">
                <h2
                  className="picksampletitle"
                  style={{ marginBottom: "26px" }}
                >
                  Pick a Template
                </h2>

                <Tabs
                  defaultActiveKey="all"
                  transition={false}
                  id="noanim-tab-example"
                  className="picktemplate-navbar"
                >
                  <Tab
                    className="picktemplate-navbar"
                    eventKey="all"
                    title={allTitle}
                  >
                    {getTemplateData && (
                      <TemplateListContainer
                        setImage={setImage}
                        data={getTemplateData}
                        imgClick={imgClick}
                        changeTemplate={changeTemplate}
                        usage="free"
                        templateId={templateId}
                        className="temp_view_all"
                        sampleSet={sampleSet}
                      />
                    )}
                  </Tab>
                  <Tab eventKey="premium" title={paidTitle}>
                    <TemplateListContainer
                      changeTemplate={changeTemplate}
                      setImage={setImage}
                      imgClick={imgClick}
                      paidTemplate={
                        getTemplateData
                          ? getTemplateData &&
                            getTemplateData.filter((data) => data.usage == "2")
                          : ""
                      }
                      usage="2"
                      templateId={templateId}
                      sampleSet={sampleSet}
                    />
                  </Tab>
                </Tabs>
                <div className="close-div d-block d-sm-block d-md-none">
                  <img
                    src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                    alt="closeicon"
                    className="sample-selected-close"
                    onClick={sampleHide}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            </div>

            <div className="d-none d-sm-none d-md-block col-md-8">
              <div className="sample-selected-img-div">
                <div className="sample_preview_image">
                  <div className=" ">
                    {image == "" ? (
                      <Skeleton
                        height="100vh"
                        containerClassName="avatar-skeleton"
                      />
                    ) : (
                      <img className=" pick_temp_img w-100 " src={image} />
                    )}

                    <div
                      className="circle_shape_left"
                      onClick={handlePrevious}
                      style={
                        current == 0 ? { opacity: "0.2" } : { opacity: "1" }
                      }
                    >
                      <i
                        class="fa fa-chevron-left"
                        style={{ margin: "35% 33%", fontSize: "23px" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div
                      className="circle_shape_right"
                      onClick={handleNext}
                      style={
                        total - 1 == current
                          ? { opacity: "0.2" }
                          : { opacity: "1" }
                      }
                    >
                      <i
                        class="fa fa-chevron-right"
                        style={{ margin: "35% 43%", fontSize: "23px" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <div
                    className=" template-use-box"
                    onClick={() => sampleSet()}
                  >
                    <h5
                      className="card-title text-center "
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-check pr-3"></i>
                      Use this template
                    </h5>
                  </div>

                  <div className="close-div">
                    <img
                      src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                      alt="closeicon"
                      className="sample-selected-close"
                      onClick={sampleHide}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Picktemplate;
